module.exports = __webpack_public_path__ + "ecomondo_news-foto-2.jpg?3233d590190be2c8223668bcd8cbb7e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo_news-foto-2.jpg
// module id = 181
// module chunks = 0